/*
  navigationGuard
  Global registry that lets a page with unsaved state veto navigation
  triggers that don't go through an <a>/<Link> click — programmatic
  navigate() calls behind buttons (header Projects/Companies/Admin,
  "View All Projects"), sidebar project/scenario switches, and logout.
  In-app anchor clicks are covered separately by useUnsavedChangesGuard's
  capture-phase document click listener, and full page unloads by its
  beforeunload handler.

  Usage (navigation trigger side):
    if (!confirmNavigation()) return;   // no-op unless a page registered a guard

  Usage (page side): see shared/hooks/useUnsavedChangesGuard.js.
*/

// () => string | null — returns the confirm message, or null when the page
// currently has nothing unsaved. Only one page-level guard exists at a time.
let activeGuard = null;

export function registerNavigationGuard(getMessage) {
  activeGuard = getMessage;
  return () => {
    if (activeGuard === getMessage) activeGuard = null;
  };
}

// Returns true when navigation may proceed (asking the user if needed).
export function confirmNavigation() {
  if (!activeGuard) return true;
  const message = activeGuard();
  if (!message) return true;
  return window.confirm(message);
}
